export const getQueryParam = (location, queryName) => {
  const queryParams = new URLSearchParams(location.search);
  return  queryParams.get(queryName);
}
